import { Tabs } from "antd";
import {
  Settings,
  Image,
  Info,
  GitBranch,
  FileText,
  Menu,
  Calendar,
  Globe,
  Upload,
  Clock,
} from "react-feather";

// Your sections
import GeneralSection from "./sections/GeneralSection";
import FlowSection from "./sections/FlowSection";
import SeoSection from "./sections/SeoSection";
import MenuSection from "./sections/MenuSection";
import EventsSection from "./sections/EventsSection";
import PublishSection from "./sections/PublishSection";
import BookingFormSettingsSection from "./sections/BookingFormSettingsSection";
import BrandingAndSectionsEditor from "./editor/BrandingAndSectionsEditor";
import RestaurantInfoEditor from "./editor/RestaurantInfoEditor";

// ✅ NEW
import WorkingHoursSection from "./sections/WorkingHoursSection";

export default function ExperienceTabs({
  config,
  loading,
  onChange,
  activeKey,
  onTabChange,
}) {
  const safeConfig = config || {};

  return (
    <>
      {/* Premium Underline-Style CSS */}
      <style jsx>{`
        .underline-tabs .ant-tabs-nav {
          margin-bottom: 0;
          background: #ffffff;
          padding: 0 32px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
          border-radius: 12px 12px 0 0;
        }
        
 .ant-tabs-nav-operations {
  display: flex;
  align-items: center;
  padding-right: 8px;
}



/* Optional: nicer arrow version */
.ant-tabs-nav-operations::before {
  content: ">>";
  font-size: 18px;
  color: #999;
  letter-spacing: 0.5px;
}
        
        .underline-tabs .ant-tabs-tab {
          padding: 18px 24px !important;
          margin: 0;
          font-size: 16px !important;
          font-weight: 600 !important;
          color: #666;
          position: relative;
          transition: color 0.3s ease;
        }

        .underline-tabs .ant-tabs-tab:hover {
          color: #0050b3;
        }

        .underline-tabs .ant-tabs-tab-active {
          color: #0050b3 !important;
        }

        .underline-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
          color: #0050b3 !important;
        }

        .underline-tabs .ant-tabs-ink-bar {
          height: 3px !important;
          background: #0050b3 !important;
          border-radius: 2px;
          bottom: 0;
        }

        .underline-tabs .tab-icon {
          width: 20px;
          height: 20px;
          margin-right: 10px;
          stroke-width: 2.2;
        }

        .underline-tabs .ant-tabs-content-holder {
          background: #fafbff;
          border-radius: 0 0 12px 12px;
          padding: 32px;
          min-height: 600px;
        }

        .underline-tabs .section-title {
          font-size: 24px;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 32px;
          padding-bottom: 12px;
          border-bottom: 1px solid #e8e8e8;
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .underline-tabs .section-title-icon {
          color: #0050b3;
        }
      `}</style>

      <div className="underline-tabs">
        <Tabs
          activeKey={activeKey}
          onChange={onTabChange}
          tabPosition="top"
          size="large"
          destroyInactiveTabPane={false}
          items={[
            {
              key: "general",
              label: (
                <span>
                  <Settings className="tab-icon" />
                  General
                </span>
              ),
              children: (
                <div>
                  <div className="section-title">
                    <Settings className="section-title-icon" />
                    General Settings
                  </div>
                  <GeneralSection
                    config={safeConfig}
                    onChange={onChange}
                    loading={loading}
                  />
                </div>
              ),
            },
            {
              key: "brandingMedia",
              label: (
                <span>
                  <Image className="tab-icon" />
                  Branding & Media
                </span>
              ),
              children: (
                <div>
                  <div className="section-title">
                    <Image className="section-title-icon" />
                    Branding & Media
                  </div>
                  <BrandingAndSectionsEditor
                    config={safeConfig}
                    onChange={onChange}
                  />
                </div>
              ),
            },
            {
              key: "restaurantInfo",
              label: (
                <span>
                  <Info className="tab-icon" />
                  Restaurant Info
                </span>
              ),
              children: (
                <div>
                  <div className="section-title">
                    <Info className="section-title-icon" />
                    Restaurant Information
                  </div>
                  <RestaurantInfoEditor
                    config={safeConfig}
                    onChange={onChange}
                  />
                </div>
              ),
            },

            // ✅ NEW TAB
            {
              key: "hours",
              label: (
                <span>
                  <Clock className="tab-icon" />
                  Working Hours
                </span>
              ),
              children: (
                <div>
                  <div className="section-title">
                    <Clock className="section-title-icon" />
                    Working Hours
                  </div>
                  <WorkingHoursSection config={safeConfig} onChange={onChange} />
                </div>
              ),
            },

            {
              key: "flow",
              label: (
                <span>
                  <GitBranch className="tab-icon" />
                  Reservation Flow
                </span>
              ),
              children: (
                <div>
                  <div className="section-title">
                    <GitBranch className="section-title-icon" />
                    Reservation Flow
                  </div>
                  <FlowSection config={safeConfig} onChange={onChange} />
                </div>
              ),
            },
            {
              key: "bookingForm",
              label: (
                <span>
                  <FileText className="tab-icon" />
                  Booking Form
                </span>
              ),
              children: (
                <div>
                  <div className="section-title">
                    <FileText className="section-title-icon" />
                    Booking Form Settings
                  </div>
                  <BookingFormSettingsSection
                    config={safeConfig}
                    onChange={onChange}
                  />
                </div>
              ),
            },
            {
              key: "menu",
              label: (
                <span>
                  <Menu className="tab-icon" />
                  Menu
                </span>
              ),
              children: (
                <div>
                  <div className="section-title">
                    <Menu className="section-title-icon" />
                    Menu Management
                  </div>
                  <MenuSection config={safeConfig} onChange={onChange} />
                </div>
              ),
            },
            {
              key: "events",
              label: (
                <span>
                  <Calendar className="tab-icon" />
                  Events / Parties
                </span>
              ),
              children: (
                <div>
                  <div className="section-title">
                    <Calendar className="section-title-icon" />
                    Events & Private Parties
                  </div>
                  <EventsSection config={safeConfig} onChange={onChange} />
                </div>
              ),
            },
            {
              key: "seo",
              label: (
                <span>
                  <Globe className="tab-icon" />
                  SEO & Domain
                </span>
              ),
              children: (
                <div>
                  <div className="section-title">
                    <Globe className="section-title-icon" />
                    SEO & Custom Domain
                  </div>
                  <SeoSection config={safeConfig} onChange={onChange} />
                </div>
              ),
            },
            {
              key: "publish",
              label: (
                <span>
                  <Upload className="tab-icon" />
                  Publish
                </span>
              ),
              children: (
                <div>
                  <PublishSection config={safeConfig} />
                </div>
              ),
            },
          ]}
        />
      </div>
    </>
  );
}
